import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import ViewContainerContext from '../../containers/ViewContainerContext';

// IMPORTANT: Do not modify this value without consideration.
// This allows the sandbox to prevent scripts, popups, etc.
// We likely need a security review to expand our html sandbox capabilities if we want to allow more interactivity in the future.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HTML_VIEWER_SANDBOX = '';
const StyledIframe = styled.iframe.withConfig({
  displayName: "HtmlViewer__StyledIframe"
})(["flex:1;inline-size:100%;block-size:100%;min-block-size:0;border:none;background-color:white;"]);
const StyledLoadingOverlay = styled.div.withConfig({
  displayName: "HtmlViewer__StyledLoadingOverlay"
})(["position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;"]);
const HtmlDocumentFrame = ({
  url,
  title,
  anchorId
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return /*#__PURE__*/_jsxs(Flex, {
    position: "relative",
    flex: 1,
    minBlockSize: "0",
    children: [!isLoaded && /*#__PURE__*/_jsx(StyledLoadingOverlay, {
      "data-test-id": "html-viewer-loading",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        label: unescapedText('a11y.htmlLoading'),
        showLabel: false
      })
    }), /*#__PURE__*/_jsx(StyledIframe, {
      id: anchorId,
      "data-test-id": "html-viewer",
      src: url,
      title: title,
      sandbox: HTML_VIEWER_SANDBOX,
      referrerPolicy: "no-referrer",
      onLoad: () => setIsLoaded(true)
    })]
  });
};
const HtmlViewer = ({
  url,
  title,
  anchorId,
  sharedLinkId
}) => {
  const {
    isPreview
  } = useContext(ViewContainerContext);
  useEffect(() => {
    if (!url) {
      Raven.captureMessage('HTML document has no render URL', {
        level: 'warning',
        extra: {
          sharedLinkId,
          isPreview
        }
      });
    }
  }, [url, sharedLinkId, isPreview]);
  if (!url) {
    return /*#__PURE__*/_jsxs(TFlex, {
      id: anchorId,
      tabIndex: -1,
      align: "center",
      direction: "column",
      marginBlockStart: "300",
      paddingInline: "400",
      "data-test-id": "html-viewer-empty",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-records",
        width: 150,
        marginBlockEnd: "300"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.html.empty.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.html.empty.description"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(HtmlDocumentFrame, {
    url: url,
    title: title,
    anchorId: anchorId
  }, url);
};
export default HtmlViewer;